export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f16d66f039b54881ebf825300f5d924d697eda7cb&name=fetchTypeahead!'